import { formatMoney } from '@Utils/Functions';
import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react';
import { useSearchResultsFilters } from 'shared-components/ViewFragments/SearchResults/Sider/Filters/SearchResultsFilters.hook';

interface PendingFiltersContextType {
  pendingFilters: any;
  setPendingFilter: (filterType: string, value: any) => void;
  clearPendingFilters: () => void;
  applyPendingFilters: () => void;
}

const PendingFiltersContext = createContext<PendingFiltersContextType | undefined>(undefined);

export const usePendingFilters = () => {
  const context = useContext(PendingFiltersContext);
  if (!context) {
    throw new Error('usePendingFilters must be used within a PendingFiltersProvider');
  }
  return context;
};

interface PendingFiltersProviderProps {
  children: ReactNode;
}

export const PendingFiltersProvider: React.FC<PendingFiltersProviderProps> = ({ children }) => {
  const [pendingFilters, setPendingFilters] = useState<any>({});
  const { changeFiltersAndUpdateURL } = useSearchResultsFilters();

  const setPendingFilter = (filterType: string, value: any) => {
    setPendingFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
  };

  const clearPendingFilters = useCallback(() => {
    setPendingFilters({});
  }, []);

  const applyPendingFilters = useCallback(() => {
    if (Object.keys(pendingFilters).length > 0) {
      changeFiltersAndUpdateURL({
        ...pendingFilters?.price,
        ...pendingFilters?.surface,
        ...pendingFilters?.guests
      });
      clearPendingFilters();
    }
  }, [pendingFilters, changeFiltersAndUpdateURL]);

  return (
    <PendingFiltersContext.Provider value={{
      pendingFilters,
      setPendingFilter,
      clearPendingFilters,
      applyPendingFilters
    }}>
      {children}
    </PendingFiltersContext.Provider>
  );
}; 